import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

export interface ResumeDownloadProps {
    altText?: string;
    className?: string;
    variant?: 'button' | 'card' | 'pill';
}

const ResumeDownload: React.FC<ResumeDownloadProps> = ({
    altText,
    className = '',
    variant = 'button',
}) => {
    const { t } = useLanguage();
    const pdfUrl = '/cv-jose-eduardo-rendon.pdf';
    const label = altText || t('resume_download_btn');

    if (variant === 'pill') {
        return (
            <a
                href={pdfUrl}
                download="Hoja_de_vida_Jose_Eduardo_Rendon.pdf"
                target="_blank"
                rel="noreferrer"
                className={`resume-pill-btn ${className}`}
                title={label}
            >
                <i className="fa fa-file-pdf-o" aria-hidden="true" style={{ marginRight: 6 }}></i>
                <span>{label}</span>
            </a>
        );
    }

    if (variant === 'card') {
        return (
            <div className={`resume-download-card ${className}`}>
                <div className="resume-card-content">
                    <i className="fa fa-file-pdf-o resume-icon" aria-hidden="true"></i>
                    <div>
                        <h4>{t('resume_card_title')}</h4>
                        <p>{t('resume_card_desc')}</p>
                    </div>
                </div>
                <a
                    href={pdfUrl}
                    download="Hoja_de_vida_Jose_Eduardo_Rendon.pdf"
                    target="_blank"
                    rel="noreferrer"
                    className="win-btn resume-btn"
                >
                    <i className="fa fa-download" aria-hidden="true" style={{ marginRight: 6 }}></i>
                    {label}
                </a>
            </div>
        );
    }

    return (
        <a
            href={pdfUrl}
            download="Hoja_de_vida_Jose_Eduardo_Rendon.pdf"
            target="_blank"
            rel="noreferrer"
            className={`verMas win-btn resume-download-link ${className}`}
        >
            <i className="fa fa-download" aria-hidden="true" style={{ marginRight: 6 }}></i>
            {label}
        </a>
    );
};

export default ResumeDownload;
